module.exports = __webpack_public_path__ + "media/audio19.bde18e7c.wav";